import {
    BrowserCacheLocation,
    Configuration,
    LogLevel,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { LocalStorageService } from './shared/local-storage/local-storage.service';

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.signUpSignInPolicyName,
  },
  authorities: {
    signUpSignIn: {
      authority: `${environment.authorityBase}/${environment.signUpSignInPolicyName}`,
    }
  },
  authorityDomain: environment.authorityDomain,
};

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.defaultClientId, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: environment.loginRedirectUri, // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
    postLogoutRedirectUri: environment.logoutRedirectUri, // Points to window.location.origin by default.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    claimsBasedCachingEnabled: true
  },
  system: {
    /**
     * Below you can configure MSAL.js logs. For more information, visit:
     * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
     */
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: environment.logLevel,
      piiLoggingEnabled: false
    },
    tokenRenewalOffsetSeconds: 300, // Sets the window of offset needed to renew the token before expiry. E.g., if acquireTokenSilent() is called within 300 seconds of tokens expiring, the call will attempt to refresh the tokens
  }
}

export const loginRequest = {
  scopes: [environment.scope],
};